//@flow
import React, { Component } from 'react';
import { type Currencies } from '../../../../utilities/types';
import { type TableRowOptionProps } from '../..';
import TableRowDevicePartial from './TableRowDevicePartial';
import TotalCurrencyBreakdown from '../TotalCurrencyBreakdown';

type Props = {
  toggleState?: string,
  currencies?: Currencies,
  setToggleState: () => void,
  tableRowOptions: TableRowOptionProps
};

export default class TableRowDeviceRow2 extends Component<Props> {
  render() {
    return (
      <>
        {this.props.toggleState && (
          <TotalCurrencyBreakdown
            // $FlowFixMe
            Partial={<TableRowDevicePartial />}
            currencies={this.props.currencies || {}}
            data={this.props.tableRowOptions.device.row2.breakdown.data || []}
            columns={
              this.props.tableRowOptions.device.row2.breakdown.columns || []
            }
          />
        )}
        <TableRowDevicePartial
          first
          bold
          options={this.props.tableRowOptions.device.row2.total}
          setToggleState={this.props.setToggleState}
          toggleState={this.props.toggleState}
        />
      </>
    );
  }
}
